/* src/app/components/ApproveTable/index.js */

import React from 'react';
import PropTypes from 'prop-types';
import { map, isEmpty, toLower, omitBy } from 'lodash';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { ThumbDown, ThumbUp } from '@material-ui/icons';

import LoadingIndicator from '../LoadingIndicator';

import { upperFirst } from '../../../util';
import { statusColors } from '../../../config/constants/styles';
import styles from './styles';
import { loadTexts } from '../../../config/texts';
const TEXT_KEY = 'components';

const ApproveTable = props => {
  const { classes, data, color, onApprove, onReject, loading, hover, onRowClick, locale } = props;
  const texts = loadTexts(TEXT_KEY, locale);
  return (
    <div className={classes.root}>
      <Table>
        <TableHead>
          <TableRow className={classes.header}>
            {!isEmpty(data) &&
              <React.Fragment>
                {map(omitBy(data[0].fields, (v, k) => k.startsWith('_')), (v, k) => (
                  <TableCell className={classes.cell} key={k} padding="none">
                    {upperFirst(k)}
                  </TableCell>
                ))}
                <TableCell className={classes.cell} padding="none">
                  {`${texts.button_text.confirm}?`}
                </TableCell>
              </React.Fragment>
            }
          </TableRow>
        </TableHead>
        <TableBody>
          {!isEmpty(data) && map(data, ({ fields, status, user }) => (
            <TableRow
              key={fields._id}
              style={{ backgroundColor: color ? statusColors[toLower(status)] : '' }}
              hover={hover}
              onClick={() => onRowClick(({ fields, user, status }))}
            >
              {map(omitBy(fields, (v, k) => k.startsWith('_')), (v, k) => (
                <TableCell key={k} className={classes.cell} padding="none">
                  {v}
                </TableCell>
              ))}
              <TableCell padding="none" className={classes.cell}>
                <IconButton
                  disabled={status === 'APPROVED'}
                  onClick={e => {
                    e.stopPropagation();
                    onApprove({
                      fields,
                      user,
                      subID: fields._id,
                      status: 'APPROVED',
                    });
                  }}
                >
                  <ThumbUp />
                </IconButton>
                <IconButton
                  disabled={status === 'DECLINED'}
                  onClick={e => {
                    e.stopPropagation();
                    onReject({
                      fields,
                      user,
                      subID: fields._id,
                      status: 'DECLINED',
                    });
                  }}
                >
                  <ThumbDown />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <LoadingIndicator loading={loading} />
    </div>
  );
};

ApproveTable.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired, // TODO: describe shape
  color: PropTypes.bool,
  onApprove: PropTypes.func,
  onReject: PropTypes.func,
  loading: PropTypes.bool,
  hover: PropTypes.bool,
  onRowClick: PropTypes.func,
};

ApproveTable.defaultProps = {
  color: false,
  onApprove: () => {},
  onReject: () => {},
  loading: false,
  hover: false,
  onRowClick: () => {},
};


const mapStateToProps = state => ({
  locale: state.appState.locale,
});


export default compose(
  withStyles(styles, { name: 'ApproveTable' }),
  connect(mapStateToProps, {})
)(ApproveTable);



// WEBPACK FOOTER //
// ./src/app/components/ApproveTable/index.js